// Written in this round about way for babel-transform-imports
import Router from "react-router/es/Router";

export default Router;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/es/Router.js
// module id = 93
// module chunks = 0